// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#f0f0f0","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#01968c","menuHover":"#000","subMenuBg":"#01968c","subMenuHover":"#000","sideBarWidth":"180px"};